
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
//import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LaptopOutlinedIcon from '@mui/icons-material/LaptopOutlined';
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import {
    Button, Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {useLocation, useNavigate } from 'react-router-dom';

import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import imgConfidentielle from '../../Pages/Expert/AO/imageConfidentielle.png';
import imgNotAvailable from '../../Pages/Expert/AO/imageNotAvailable.png';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { getEntrepriseInfoRoleBased } from '../../Utils/utils';
import { getPaymentSimulationResults } from '../../Utils/utilsCraX';
import {buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';

function HeaderAoDescription ({ao,typeAction, isExpertAlreadyPostulate,isUrlFromCandidature,isFromCreateAO}){
    HeaderAoDescription.propTypes = {
        ao: PropTypes.any,
        typeAction: PropTypes.any,
        isUrlFromCandidature:PropTypes.any,
        isExpertAlreadyPostulate: PropTypes.any,
        isFromCreateAO: PropTypes.bool,
    };
    const role = useRole();
    const navigate = useNavigate();
    const {device}=useWindowSize();
    const [aoCloture,setAoCloture]=useState(false);
    const { i18n } = useTranslation();
    const {pathname}=useLocation();
    useEffect(() => {
        if (new Date(ao?.dateFinAO) < new Date()) {
            setAoCloture(true);
        }
    }, [ao]);

    const checkApplicationStatus = () => {
        if (isExpertAlreadyPostulate) {
            return 'vous avez déjà postulé à cet appel d\'offres';
        } else if (aoCloture) {
            return 'Cet AO est clôturé!';
        } else {
            return '';
        }
    };

    // const checkApplicationStatus = () => {
    //     if (isExpertAlreadyPostulate) {
    //         return 'vous avez déjà postulé à cet appel d\'offres';
    //     } else if (new Date(ao?.dateFinAO) < new Date()) {
    //         setAoCloture(true);
    //         return 'Cet AO est clôturé!';
    //     } else {
    //         return '';
    //     }
    // };

    console.log('aooo',ao,'logo',ao?.companyDataId?.profileEntreprise.logo ?? ao?.esnId?.profileEntreprise.logo);
    return (
        <>
            <div className='aodet2'>
                <div className='aodet3'>
                    <img
                        style={{display: 'flex',flexDirection: 'row',alignItems: 'flex-start',gap: '10px',width: '100px',height: '100px',borderRadius: '20px',flex: 'none',order: 0,flexGrow: 0}}
                        //to ask Madame FZ nd Reda
                        //src={ao?.companyDataId?.profileEntreprise?.logo ? ao?.companyDataId?.profileEntreprise?.logo : imgNoLogoFound}
                        //className='AOImage'
                        //src={getEntrepriseInfoRoleBased({
                        //    info2Display:ao?.companyDataId?.profileEntreprise.logo,
                        //    isVisible2Expert: !(ao?.entrepriseData?.nomEntrepriseConfidentiel),
                        //    role: role
                        //})=='Non précisé'? imgConfidentielle:(ao?.companyDataId?.profileEntreprise.logo !== undefined ? ao?.companyDataId?.profileEntreprise?.logo : imgNotAvailable)}
                        src={(ao?.entrepriseData?.nomEntrepriseConfidentiel==true )? imgConfidentielle : ((ao?.companyDataId?.profileEntreprise?.logo !== undefined ?? ao?.esnId?.profileEntreprise?.logo !== undefined) ? imgNotAvailable : (ao?.companyDataId?.profileEntreprise?.logo ?? ao?.esnId?.profileEntreprise?.logo)  )}
                    />
                    <div className='AOTitlestyleLA'>
                        <p className='titredao'>
                            {getEntrepriseInfoRoleBased({
                                info2Display:ao?.entrepriseData?.entrepriseName,
                                isVisible2Expert: !(ao?.entrepriseData?.nomEntrepriseConfidentiel),
                                role: (role=='esn' ? (pathname.includes('aoHTH') ? 'esnExpert':'esnClient'): role)
                            })=='Non précisé' ? 'Confidentiel' : ao?.entrepriseData?.entrepriseName}
                            | {i18n.t('Réf')}: {ao?.aoId || '__________'}</p>
                        <h5 className='HomeFrameAos textcardidstyle'>{ao?.intitulePoste || '_________________'}</h5>
                    </div>
                </div>
                <div
                    className='caltime'
                >
                    {((role =='expert' && !isUrlFromCandidature) || (role=='esn' && pathname.includes('aoHTH') && !isUrlFromCandidature) )&&
                        <>
                            {typeAction!='postulate' &&
                            <Tooltip
                                title={checkApplicationStatus()}
                            >
                                <span style={{width:'100%'}}>
                                    <Button
                                        variant="contained"
                                        onClick={()=>{
                                            if(ao?._id){
                                                if(role!='esn')
                                                    navigate(`/${role}/ao/postulate/${ao._id}`,{ replace: true });
                                                else
                                                    navigate(`/${role}/aoHTH/postulate/${ao._id}`,{ replace: true });
                                            }
                                        }}
                                        disabled={checkApplicationStatus()?true:false}
                                        style={{
                                            ...buttonStylesGreen((isExpertAlreadyPostulate||aoCloture)), ...{
                                                width:device=='desktop'?'156px':'100%',
                                                height: '36px',
                                            }
                                        }}
                                    >
                                        {i18n.t('Répondre à l\'offre')}
                                    </Button>
                                </span>
                            </Tooltip>
                            }
                            <div style={{display:'flex',flexDirection:device=='desktop' ?'column':'row',gap:'4px',alignSelf: device=='desktop'?'flex-end':'flex-start'}}>
                                <p className='TextFrame21'>
                                    {i18n.t('A répondre avant')}
                                </p>
                                <div style={{display:'flex',flexDirection:'row',gap:'4px'}}>
                                    <CalendarTodayIcon />
                                    <p className='datestyilng'>{formatDateJJMMYYYY(ao?.dateFinAO)}</p>
                                </div>
                            </div>
                        </>
                    }

                    {(role =='client' ||(role=='esn' && !pathname.includes('aoHTH') && !isUrlFromCandidature)|| (role =='admin' && ao?.backOfficeId)) &&
                        <>
                            <div style={{display:'flex',alignSelf:'stretch'}}>
                                {isFromCreateAO ?
                                    <Button
                                        className='modifie'
                                        variant='contained'
                                        //color='success'
                                        style={{...buttonStylesGreen(false),...{width: '100%',height: '36px'}}}
                                        onClick={()=>
                                            navigate(`/${role}/createAO/last`)
                                        }
                                    >{i18n.t('Retour')}</Button>
                                    :
                                    <Button
                                        className='modifie'
                                        variant='contained'
                                        //color='success'
                                        style={{...buttonStylesGreen(false),...{width: '100%',height: '36px'}}}
                                        onClick={()=>
                                            navigate(`/${role}/createAO`,{state:{aoId:ao?._id}})
                                        //<Navigate
                                        //    to="/client/createAO/next/"
                                        //    state={{id:ao?._id }}
                                        //    replace
                                        ///>
                                        //http://localhost:3000/client/createAO/last+ao?._id
                                        }
                                    >{i18n.t('Modifier')}</Button>}
                            </div>
                            <div className='stykedat'>
                                <p className='publiele'>{i18n.t('Début de publication')} : </p>
                                <div style={{display:'flex',flexDirection:'row',gap:'4px'}}>
                                    <CalendarTodayIcon />
                                    <p className='textIconsStyle'>{formatDateJJMMYYYY(ao?.dateDebutAO)}</p>
                                </div>
                            </div>
                            <div className='stykedat'>
                                <p className='publiele publiele1'>{i18n.t('Fin de publication')} : </p>
                                <div style={{display:'flex',flexDirection:'row',gap:'4px'}}>
                                    <CalendarTodayIcon />
                                    <p className='textIconsStyle'>{formatDateJJMMYYYY(ao?.dateFinAO)}</p>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>

            <div>
                <div
                    className='Frame22ADBILA'
                    style={{flexWrap:'wrap'}}
                >
                    {ao?.dateDebutMission &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>
                                {i18n.t('Date de début souhaitée')}
                            </p>
                            <div className='Frame21B2LA'>
                                <CalendarTodayIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{formatDateJJMMYYYY(ao?.dateDebutMission)}</p>

                            </div>
                        </div>
                    }
                    {ao?.dureeMission &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>
                                {i18n.t('Durée de la mission')}
                            </p>
                            <div className='Frame21B2LA'>
                                <AccessTimeIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.dureeMission} {i18n.t('jours')}</p>
                            </div>
                        </div>
                    }
                    {ao?.dureeBDC &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>
                                {i18n.t('Durée du BDC')}
                            </p>
                            <div className='Frame21B2LA'>
                                <EventAvailableIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.dureeBDC+' mois'}</p>
                            </div>
                        </div>
                    }
                    {ao?.tjMax &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>
                                {i18n.t('Budget')}
                            </p>
                            <div className='Frame21B2LA'>
                                <svg
                                    width="18"
                                    height="19"
                                    viewBox="0 0 18 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.1875 3.41406C6.22266 3.44922 6.25781 3.51953 6.36328 3.625C6.36328 3.625 6.39844 3.625 6.39844 3.66016C5.73047 3.66016 5.09766 3.69531 4.5 3.80078V3.34375C4.5 2.71094 4.81641 2.21875 5.23828 1.86719C5.625 1.48047 6.15234 1.19922 6.75 0.988281C7.94531 0.53125 9.52734 0.25 11.25 0.25C12.9375 0.25 14.5195 0.53125 15.7148 0.988281C16.3125 1.19922 16.8398 1.48047 17.2266 1.86719C17.6484 2.21875 18 2.71094 18 3.34375V10.6562C18 11.2891 17.6484 11.8164 17.2266 12.168C16.8398 12.5547 16.3125 12.8359 15.7148 13.0469C15.3633 13.1875 15.0117 13.293 14.625 13.3984V11.6406C14.8008 11.6055 14.9414 11.5352 15.1172 11.4648C15.5742 11.2891 15.9258 11.1133 16.1016 10.9375C16.207 10.832 16.2422 10.7617 16.2773 10.7266C16.3125 10.6914 16.3125 10.6562 16.3125 10.6562V9.14453C16.1016 9.25 15.9258 9.32031 15.7148 9.39062C15.3633 9.53125 15.0117 9.63672 14.625 9.74219V7.98438C14.8008 7.94922 14.9414 7.87891 15.1172 7.80859C15.5742 7.63281 15.9258 7.45703 16.1016 7.28125C16.207 7.17578 16.2422 7.10547 16.2773 7.07031C16.2773 7.03516 16.2773 7.03516 16.3125 7V5.48828C16.1016 5.59375 15.9258 5.66406 15.7148 5.73438C15.2227 5.91016 14.6602 6.08594 14.0977 6.19141C13.8867 5.91016 13.7109 5.69922 13.5 5.52344C13.1484 5.20703 12.7266 4.92578 12.3047 4.71484C13.3945 4.64453 14.3789 4.43359 15.1172 4.15234C15.5742 3.97656 15.9258 3.80078 16.1016 3.625C16.207 3.51953 16.2422 3.44922 16.2773 3.41406C16.2773 3.37891 16.2773 3.37891 16.3125 3.34375C16.3125 3.34375 16.3125 3.34375 16.2773 3.30859C16.2422 3.27344 16.207 3.20312 16.1016 3.09766C15.9258 2.92188 15.5742 2.74609 15.1172 2.57031C14.168 2.18359 12.7969 1.9375 11.25 1.9375C9.66797 1.9375 8.29688 2.18359 7.34766 2.57031C6.89062 2.74609 6.53906 2.92188 6.36328 3.09766C6.25781 3.20312 6.22266 3.27344 6.1875 3.30859C6.15234 3.34375 6.15234 3.34375 6.15234 3.34375C6.1875 3.37891 6.1875 3.37891 6.1875 3.41406ZM0 7.84375C0 7.21094 0.316406 6.71875 0.738281 6.36719C1.125 5.98047 1.65234 5.69922 2.25 5.48828C3.44531 5.03125 5.02734 4.75 6.75 4.75C8.4375 4.75 10.0195 5.03125 11.2148 5.48828C11.8125 5.69922 12.3398 5.98047 12.7266 6.36719C13.1484 6.71875 13.5 7.21094 13.5 7.84375V15.1562C13.5 15.7891 13.1484 16.3164 12.7266 16.668C12.3398 17.0547 11.8125 17.3359 11.2148 17.5469C10.0195 18.0039 8.4375 18.25 6.75 18.25C5.02734 18.25 3.44531 18.0039 2.25 17.5469C1.65234 17.3359 1.125 17.0547 0.738281 16.668C0.316406 16.3164 0 15.7891 0 15.1562V7.84375ZM1.6875 7.91406C1.72266 7.94922 1.75781 8.01953 1.86328 8.125C2.03906 8.30078 2.39062 8.47656 2.84766 8.65234C3.79688 9.03906 5.16797 9.25 6.75 9.25C8.29688 9.25 9.66797 9.03906 10.6172 8.65234C11.0742 8.47656 11.4258 8.30078 11.6016 8.125C11.707 8.01953 11.7422 7.94922 11.7773 7.91406C11.7773 7.87891 11.7773 7.87891 11.8125 7.84375C11.8125 7.84375 11.8125 7.84375 11.7773 7.80859C11.7422 7.77344 11.707 7.70312 11.6016 7.59766C11.4258 7.42188 11.0742 7.24609 10.6172 7.07031C9.66797 6.68359 8.29688 6.4375 6.75 6.4375C5.16797 6.4375 3.79688 6.68359 2.84766 7.07031C2.39062 7.24609 2.03906 7.42188 1.86328 7.59766C1.75781 7.70312 1.72266 7.77344 1.6875 7.80859C1.65234 7.84375 1.65234 7.84375 1.6875 7.84375C1.6875 7.87891 1.6875 7.87891 1.6875 7.91406ZM11.8125 9.98828C11.6016 10.0938 11.4258 10.1641 11.2148 10.2344C10.0195 10.6914 8.4375 10.9375 6.75 10.9375C5.02734 10.9375 3.44531 10.6914 2.25 10.2344C2.03906 10.1641 1.86328 10.0938 1.6875 9.98828V11.5C1.6875 11.5352 1.6875 11.5352 1.6875 11.5703C1.72266 11.6055 1.75781 11.6758 1.86328 11.7812C2.03906 11.957 2.39062 12.1328 2.84766 12.3086C3.79688 12.6953 5.16797 12.9062 6.75 12.9062C8.29688 12.9062 9.66797 12.6953 10.6172 12.3086C11.0742 12.1328 11.4258 11.957 11.6016 11.7812C11.707 11.6758 11.7422 11.6055 11.7773 11.5703C11.7773 11.5352 11.7773 11.5352 11.8125 11.5V9.98828ZM2.25 13.8906C2.03906 13.8203 1.86328 13.75 1.6875 13.6445V15.1562C1.65234 15.1562 1.65234 15.1914 1.6875 15.2266C1.72266 15.2617 1.75781 15.332 1.86328 15.4375C2.03906 15.6133 2.39062 15.7891 2.84766 15.9648C3.79688 16.3516 5.16797 16.5625 6.75 16.5625C8.29688 16.5625 9.66797 16.3516 10.6172 15.9648C11.0742 15.7891 11.4258 15.6133 11.6016 15.4375C11.707 15.332 11.7422 15.2617 11.7773 15.2266C11.8125 15.1914 11.8125 15.1562 11.8125 15.1562V13.6445C11.6016 13.75 11.4258 13.8203 11.2148 13.8906C10.0195 14.3477 8.4375 14.5938 6.71484 14.5938C5.02734 14.5938 3.44531 14.3477 2.25 13.8906Z"
                                        fill="#272D3C"
                                    />
                                </svg>
                                <p className='textIconsStyle'>{
                                    getEntrepriseInfoRoleBased({
                                        info2Display: (role=='expert'||(role=='esn' && pathname.includes('aoHTH'))) && !isUrlFromCandidature ? getPaymentSimulationResults({ tjClient: ao?.tjMax, commissionHTH: 0.2 })?.tj : ao?.tjMax,
                                        isVisible2Expert: ao?.visibilityTjMax,
                                        role: (role=='esn' ? (pathname.includes('aoHTH') ? 'esnExpert':'esnClient'): role)
                                    })!='Non précisé' ?
                                        getEntrepriseInfoRoleBased({
                                            info2Display:(role=='expert'||(role=='esn' && pathname.includes('aoHTH'))) ? getPaymentSimulationResults({ tjClient: ao?.tjMax, commissionHTH: 0.2 })?.tj : ao?.tjMax,
                                            isVisible2Expert: ao?.visibilityTjMax,
                                            role: (role=='esn' ? (pathname.includes('aoHTH') ? 'esnExpert':'esnClient'): role)
                                        }) + ' €' : 'Non précisé'
                                }</p>
                            </div>
                        </div>
                    }
                    {ao?.localisation &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>
                                {i18n.t('Localisation')}
                            </p>
                            <div className='Frame21B2LAF'>
                                <PlaceOutlinedIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.localisation }</p>
                            </div>
                        </div>
                    }
                    {/*a poser la question*/}
                    {ao?.nbRecrutes &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>{i18n.t('Nombre de postes')}</p>
                            <div className='Frame21B2LA APPwith5LA'>
                                <PeopleAltOutlinedIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.nbRecrutes < 2 ? ao?.nbRecrutes + 'poste' : ao?.nbRecrutes + 'postes'} </p>
                            </div>
                        </div>
                    }
                    {ao?.minimumAnneeExp &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>
                                {i18n.t('Min.années d\'exp.')}
                            </p>
                            <div className='Frame21B2LA'>
                                <AccessTimeIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.minimumAnneeExp==1 ? ao?.minimumAnneeExp+ 'an' : ao?.minimumAnneeExp+ i18n.t('ans')}</p>
                            </div>
                        </div>
                    }
                    {ao?.modeTravail?.type === 'presentiel' &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>{i18n.t('Mode')}</p>
                            <div
                                className='Frame21B2LA APPwith5LA'
                            >

                                <BusinessOutlinedIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'> {i18n.t('Présentiel')}</p>
                            </div>
                        </div>
                    }
                    {ao?.modeTravail?.type === 'remote' &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>{i18n.t('Mode')}</p>
                            <div
                                className='Frame21B2LA APPwith5LA'
                            >
                                <LaptopOutlinedIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'> {i18n.t('A distance')} </p>
                            </div>
                        </div>
                    }
                    {ao?.modeTravail?.type === 'hybride' &&  ao?.modeTravail.nbJrsRemotePerWeek &&
                        <div className='Frame21LA'>
                            <p className='Frame21TitleLA'>{i18n.t('Fréq. Télétravail')}</p>
                            <div className='Frame21B2LA APPwith5LA'>
                                <LaptopOutlinedIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.modeTravail.nbJrsRemotePerWeek} {i18n.t('jours')} </p>
                            </div>
                        </div>
                    }
                    {ao?.regimeTravail?.type === 'temps-partiel' &&
                        <div
                            className='Frame21LA'
                        >
                            <p className='Frame21TitleLA'>{i18n.t('Temps partiel')}</p>
                            <div className='Frame21B2LA APPwith5LA'>
                                <DateRangeOutlinedIcon style={{ height: '16px', width: '20px' }} />
                                <p className='textIconsStyle'>{ao?.regimeTravail.nbJrsPartielPerWeek} {i18n.t('jours')}</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>

    );
}

export default HeaderAoDescription;